import { useEffect } from "react";

function cleanMTRForm(){
  document.querySelectorAll<HTMLElement>(".modal").forEach(modal=>{
    const title=[...modal.querySelectorAll("h2")].find(h=>h.textContent?.trim()==="Add material test report");
    if(!title)return;
    modal.querySelectorAll<HTMLLabelElement>("label").forEach(label=>{
      const text=(label.childNodes[0]?.textContent||label.textContent||"").trim().toLowerCase();
      if(text.startsWith("certificate number")) label.style.display="none";
    });
  });
}

export default function MTRFormCleanup(){
  useEffect(()=>{
    cleanMTRForm();
    let queued=false;
    const observer=new MutationObserver(()=>{
      if(queued)return;
      queued=true;
      requestAnimationFrame(()=>{queued=false;cleanMTRForm()});
    });
    observer.observe(document.body,{childList:true,subtree:true});
    return()=>observer.disconnect();
  },[]);
  return null;
}
